import create from "zustand";
import { getUserInfo as getUserHttp, setUserInfo as setUserInfoHttp, logOutUser as logOutUserHttp } from "api/login";
const initalUserInfo = {
  id: null,
  email: "",
  fullname: "",
  customer_type: null,
  langprefer: "tr",
  hastemppass: null,
  survey: null,
  user_token: "",
  expire_password: null,
  menus: null,
  permissions: null,
  roles: [],
  informing: null,
  cookies: {},
  isLoggedIn: false,
  ipAddress: "",
  browser: "",
  satisfactionSurvey: null,
  userNotLoaded: true,
};

// function timeout(ms) {
//   return new Promise((resolve) => setTimeout(resolve, ms));
// }

export const useUserStore = create((set, get) => ({
  userInfo: initalUserInfo,
  token: "",
  lang: "tr",
  setCurrentUser: (data) =>
    set(() => ({ userInfo: { ...data, userNotLoaded: false }, token: data?.token, lang: data?.lang })),
  clearUserStore: () => {
    sessionStorage.removeItem("test-cookie");
    set({ userInfo: initalUserInfo, token: "", lang: "tr" });
  },
  logOutUser: async () => {
    try {
      const logOutRes = await logOutUserHttp();
      console.log({logOutRes})
      if (logOutRes?.status === 200) {
        sessionStorage.removeItem("test-cookie");
        set({ userInfo: { ...initalUserInfo, userNotLoaded: false }, token: "", lang: "tr" });
        // window.location.reload()
      }
    } catch (error) {
      console.log({ error });
    }
  },
  getCurrentUser: async () => {
    try {
      const { data, status } = await getUserHttp();
      if (status === 200) {
        set({ userInfo: { ...data, isLoggedIn: true, userNotLoaded: false }, token: data?.token, lang: data?.lang });
      } else {
        set({ userInfo: initalUserInfo, userNotLoaded: false, isLoggedIn: false, token: "", lang: "" });
      }
      // await timeout(300);
      // const tempCookieData = JSON.parse(sessionStorage.getItem("test-cookie"));

      // set({ userInfo: { ...data, isLoggedIn: true, userNotLoaded: false }, token: data?.token, lang: data?.lang });
      // set({
      //   userInfo: { ...tempCookieData, isLoggedIn: tempCookieData?.id ? true : false, userNotLoaded: false },
      //   token: tempCookieData?.token,
      //   lang: tempCookieData?.lang,
      // });
      // console.log("i set the cookie");
    } catch (error) {
      set({ userInfo: initalUserInfo, userNotLoaded: false, isLoggedIn: false, token: "", lang: "" });
      console.log(error);
    }
  },
  setUserInfo: async ({ key, value }) => {
    try {
      const httpResult = await setUserInfoHttp({ key, value });
      if (httpResult?.status === 200 && httpResult?.data?.id > 0) {
        const tempStateData = get()?.userInfo;
        switch (key) {
          case "informing":
            set({ userInfo: { ...tempStateData, informing: { id: value } } });
            break;
          case "cookies":
            set({ userInfo: { ...tempStateData, cookies: { id: value } } });
            break;
          default:
            set({ userInfo: { ...tempStateData, [key]: value } });
            break;
        }
      }
    } catch (error) {
      console.log(error);
    }
  },
  setCookie: async (uData) => {
    try {
      sessionStorage.setItem("test-cookie", JSON.stringify(uData));
      // await postCookie(uData);
    } catch (error) {
      console.log(error);
    }
  },
}));
// SELECTORS
export const userSelector = (state) => state.userInfo;
export const tokenSelector = (state) => state.token;
export const langSelector = (state) => state.lang;
export const setUserSelector = (state) => state.setCurrentUser;
export const clearStoreSelector = (state) => state.clearUserStore;
export const logOutUserSelector = (state) => state.logOutUser;
export const getUserSelector = (state) => state.getCurrentUser;
export const setCookieSelector = (state) => state.setCookie;
export const setUserCookieSelector = (state) => state.setUserInfo;
// NON REACTIVE
export const getUserInfo = useUserStore.getState().userInfo;
export const getUserLanguage = useUserStore.getState().lang;
export const getTokenFromStore = useUserStore.getState().token;
export const getCurrentUser = useUserStore.getState().getCurrentUser;
